// A load belongs to one selection, even if the user switches away and back.
export const createLedgerLoadTracker = () => {
  let generation = 0;
  return {
    begin() {
      const requestGeneration = ++generation;
      return () => requestGeneration === generation;
    },
    invalidate() {
      generation += 1;
    }
  };
};

export const canPersistLedgerDataset = (renderSource, loadedSource, workspaceId, userId) => {
  // Identity also distinguishes two loads of the same workspace. Old render
  // callbacks must never save their data after a newer load completes.
  if (!userId || !renderSource || renderSource !== loadedSource || loadedSource.userId !== userId) {
    return false;
  }
  return workspaceId
    ? loadedSource.scope === 'workspace' && loadedSource.workspaceId === workspaceId
    : loadedSource.scope === 'personal' && !loadedSource.workspaceId;
};
